import { CHAT_GET_COUNT_OF_UNREAD } from '@/store';
import { ChatGetCountOfUnreadResponseType } from '@/types';

export const chatGetCountOfUnread = (payload: ChatGetCountOfUnreadResponseType) => ({
  type: CHAT_GET_COUNT_OF_UNREAD,
  payload,
});
